<template>
  <div class="hello">
    <nav class="navbar">
      <div class="navbar-l">
        <span class="shij">
          <el-button @click="onAdd" icon="el-icon-plus" type="primary">
            添加监控对象
          </el-button>
        </span>
      </div>
      <div class="navbar-r">
        <span class="shij">
          <el-input
            clearable
            style="width: 26.0rem; margin-right: 2rem;"
            placeholder="搜索成员名称"
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
          </el-input>
          <el-button @click="rune()" type="primary" slot="append"
          >查询</el-button
          >
        </span>
      </div>
    </nav>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      border
      style="width: 100%; margin-top: 3.0rem"
    >
      <el-table-column
        prop="name"
        label="名称"
        style="width: 40%"
      ></el-table-column>
      <el-table-column prop="department" label="部门">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            style="margin: .2rem"
            v-for="t in scope.row.department_array"
            :key="t"
            >{{ t }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="170" >
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row.userid)"
            size="small"
            type="text"
            style="color:#f00000 !important"
            ><img src="../../assets/移除.png" alt="">
            移除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="userTable"
        />
      </div>
    <right-people ref="dialog" :checkbox="checkbox" :module="module" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople';

export default {
  name: "monitoring",
  components: {
    rightPeople
  },
  data() {
    return {
      tableData: [],
      input2: "",
      onSubmit: false,
      tableData_a: [],
      multipleSelection: [],
      checkbox: true,
      module: "",
      ids: "",
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    // let title = JSON.parse(window.sessionStorage.getItem("title"));
    // // // // console.log(userinfo);
    // this.title = title;
    // // // console.log(this.title);
    // var a = document.title;
    // document.title = title[0].website + "-" + a;
    // // // // console.log(this.username);
    // }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      // // // console.log(userinfo);
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    onAdd() {
      this.module = "ifRemoveUserTwo";
      this.checkbox = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "ifRemoveUserTwo":
          const userid = [];
          const user = [];
          person.map((item) => {
            userid.push(item.userid);
            user.push(item.name);
          });
          if (!userid.length) {
            return;
          }
          this.ids = userid.join();
          this.numoo();
          break;
        default:
          break;
      }
    },
    userTable() {
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserOne",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
          this.total = res.data.count
        })
        .catch(function (err) {});
    },
    rune() {
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserOne",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    tianjia() {
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    numoo() {
      // // console.log(this.multipleSelection);
      // const arr = [];
      // this.multipleSelection.forEach((item) => {
      //   arr.push(item.userid);
      // });
      // console.log(arr.toString());

      this.axios
        .post(
          "/home/sessionUser/ifRemove",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            userid: this.ids,
            if_remove: 1,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e) {
      this.$confirm("您确定要移除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/home/sessionUser/ifRemove",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                userid: e.toString(),
                if_remove: 2,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tree-node:focus > .el-tree-node__content,
.el-tree-node__content:hover {
  background: #ffffff;
  color: #66b1ff;
}

</style>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.navbar {
  display: flex;
  justify-content: space-between;
}
.shij {
  display: inline-block;
}
</style>
